import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userApi } from '../api/userApi';
import type { CreateUserRequest } from '../types/user';

/**
 * POST /api/eraf/users — 신규 사용자 생성
 * 성공 시 목록 쿼리 무효화
 */
export function useCreateUser() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateUserRequest) => userApi.create(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['user-management', 'list'] });
    },
  });
}
